'use client';

import React, { useEffect, useState } from 'react';

interface MockDeployProps {
    isActive: boolean;
    onComplete: () => void;
}

export function MockDeploy({ isActive, onComplete }: MockDeployProps) {
    const [isChecking, setIsChecking] = useState(false);

    useEffect(() => {
        if (isActive) {
            runSequence();
        }
    }, [isActive]);

    const runSequence = async () => {
        await wait(500);
        // Simulate typing domain

        await wait(500);

        // Simulate Click Pay/Deploy
        setIsChecking(true);
        await wait(1500); // Processing...

        onComplete();
    };

    const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

    return (
        <div className="w-full h-full bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-300">
                <div className="p-6 border-b border-gray-100">
                    <h3 className="text-lg font-bold text-gray-900">Deploy to Production</h3>
                    <p className="text-gray-500 text-sm">Configure your site settings to go live.</p>
                </div>

                <div className="p-6 space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Subdomain</label>
                        <div className="flex rounded-md shadow-sm">
                            <span className="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 text-sm">
                                https://
                            </span>
                            <input
                                type="text"
                                disabled
                                className="flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-r-md border border-gray-300 bg-white text-sm"
                                value="my-startup"
                            />
                        </div>
                        <p className="mt-1 text-xs text-green-600 flex items-center">
                            <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                            domain available
                        </p>
                    </div>

                    <div className="bg-blue-50 p-4 rounded-lg flex items-start gap-3">
                        <input type="checkbox" checked readOnly className="mt-1 w-4 h-4 text-indigo-600 rounded border-gray-300" />
                        <div className="text-sm">
                            <span className="font-medium text-blue-900">Remove Watermark</span>
                            <p className="text-blue-700">Look professional with custom branding.</p>
                        </div>
                    </div>
                </div>

                <div className="p-6 bg-gray-50 border-t border-gray-200">
                    <button className="w-full flex items-center justify-center py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500">
                        {isChecking ? (
                            <>
                                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                Deploying...
                            </>
                        ) : (
                            "Confirm & Publish"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
}
